var React = require(`react`);

require('./Tooltip.css');

class Tooltip extends React.Component {
  static defaultProps = {
    visible: false,
    term: ``,
    desc: ``,
    x: 0,
    y: 0,
    aboveCenter: true,
    arrowX: 0 
  };

  constructor(props) {
    super(props);
    this.state = {
      visible: props.visible,
      term: props.term,
      desc: props.desc,
      x: props.x,
      y: props.y,
      aboveCenter: true,
      arrowX: props.arrowX
    };

    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
  };

  show(term, desc, rect) {
    const position = this.calculatePosition(rect);

    this.setState({
      visible: true,
      aboveCenter: position.aboveCenter,
      x: position.x,
      y: position.y,
      desc,
      term,
      arrowX: position.arrowX
    });
  }

  hide() {
    this.setState({ visible: false });
  }

  calculatePosition(rect) {
    const tooltipElement = document.querySelector('.term-definition-tooltip')
    const positioningParent = tooltipElement.parentElement;

    const documentElement = window.document.documentElement;

    const parentHeight = positioningParent.scrollHeight;
    const windowHeight = documentElement.scrollHeight;
    const heightDiff = windowHeight - parentHeight;

    const pubrContent = document.querySelector('.pubr-content');

    const parentRect = positioningParent.getBoundingClientRect();
    const contentRect = pubrContent.getBoundingClientRect();

    const tooltipWidth = 300;
    const arrowHeight = 10;
    const arrowWidth = 20;

    const targetIsAboveCenter = rect.top + rect.height / 2 <= documentElement.clientHeight / 2;

    const preferredXPos = rect.left + (rect.width - tooltipWidth) / 2;
    const boundedXPos = Math.max(contentRect.left, Math.min(contentRect.right - tooltipWidth, preferredXPos));

    const xpos = boundedXPos - parentRect.left;
    const arrowXPos = rect.left - boundedXPos + (rect.width - arrowWidth) / 2;

    const position = {
      aboveCenter: targetIsAboveCenter,
      x: xpos,
      arrowX: arrowXPos + 'px'
    };

    return targetIsAboveCenter 
      ? {
        ...position,
        y: rect.bottom + window.pageYOffset - heightDiff + arrowHeight
      }
      : {
        ...position,
        y: documentElement.clientHeight - rect.top
          + (documentElement.scrollHeight - documentElement.clientHeight - window.pageYOffset)
          + arrowHeight
      }
  }

  render() {
    const style = {
      display: this.state.visible ? `block` : `none`,
      left: this.state.x,
      [this.state.aboveCenter ? `top` : `bottom`]: this.state.y,
      "--tooltip-arrow-x": this.state.arrowX
    };

    const htmlClass = [
      `term-definition-tooltip`,
      this.state.aboveCenter ? `upper` : `lower`,
    ];

    return (
      <div class={htmlClass.join(` `)} style={style}>
        <strong>{this.state.term}</strong>
        {this.state.desc}
      </div>
    );
  }
}

module.exports = Tooltip;



// WEBPACK FOOTER //
// ./src/components/Tooltip.js